<template>
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<g>
		<path d="M356,429c-5.52,0-10,4.48-10,10c0,5.52,4.48,10,10,10c5.52,0,10-4.48,10-10C366,433.48,361.52,429,356,429z"/>
	</g>
</g>
<g>
	<g>
		<path d="M156,429c-5.52,0-10,4.48-10,10c0,5.52,4.48,10,10,10s10-4.48,10-10C166,433.48,161.52,429,156,429z"/>
	</g>
</g>
<g>
	<g>
		<path d="M447.645,377.21c-11.257-17.424-26.726-31.269-44.847-40.21c-1.528-1.419-3.493-2.37-5.678-2.613
			C384.013,328.823,370.197,326,356,326h-30v-26.383c17.361-14.896,29.842-34.626,35.894-56.617H366c22.056,0,40-17.944,40-40
			c0-10.452-4.034-19.976-10.622-27.11c0.629-0.534,1.243-1.09,1.833-1.679C402.879,168.543,406,161.01,406,153
			c0-13.163-8.526-24.366-20.343-28.396c-3.533-45.984-35.806-85.28-80.241-97.596C302.783,13.256,291.434,0,276,0h-40
			c-15.434,0-26.783,13.256-29.416,27.008c-44.431,12.315-76.701,51.604-80.24,97.582c-4.302,1.459-8.247,3.892-11.555,7.199
			C109.121,137.457,106,144.99,106,153c0,9.163,4.134,17.375,10.63,22.882C110.038,183.016,106,192.544,106,203
			c0,22.056,17.944,40,40,40h4.078c5.052,18.357,14.631,35.21,27.994,49.131c2.511,2.618,5.173,5.112,7.928,7.478V326h-30
			c-14.198,0-28.014,2.823-41.12,8.386c-2.184,0.244-4.15,1.194-5.677,2.613c-18.123,8.942-33.591,22.787-44.848,40.21
			C52.347,395.796,46,417.163,46,439v63c0,5.522,4.477,10,10,10h400c5.523,0,10-4.478,10-10v-63
			C466,417.163,459.653,395.796,447.645,377.21z M106,492H66v-53c0-30.417,15.582-59.571,40-76.878V492z M366,223h-0.456
			c0.298-3.327,0.456-6.666,0.456-10v-30c11.028,0,20,8.972,20,20S377.028,223,366,223z M206,48.139V93c0,5.523,4.477,10,10,10
			s10-4.477,10-10V35.063c0-0.026,0-0.052,0-0.078V33c0-6.196,5.234-13,10-13h40c4.766,0,10,6.804,10,13v1.985
			c0,0.026,0,0.052,0,0.078V93c0,5.523,4.477,10,10,10s10-4.477,10-10V48.139c32.29,11.427,55.6,40.647,59.441,74.861H146.559
			C150.4,88.786,173.71,59.566,206,48.139z M146,223c-11.028,0-20-8.972-20-20s8.972-20,20-20v30c0,3.334,0.158,6.674,0.456,10H146z
			 M146,163h-10c-5.514,0-10-4.486-10-10c0-2.668,1.041-5.179,2.931-7.068c1.891-1.891,4.401-2.932,7.069-2.932h240
			c5.514,0,10,4.486,10,10c0,2.668-1.041,5.179-2.931,7.068c-1.89,1.891-4.401,2.932-7.069,2.932h-10h-10H156H146z M167.817,231.183
			c-0.02-0.109-0.039-0.217-0.063-0.324C166.593,224.99,166,218.983,166,213v-30h180v30c0,5.978-0.593,11.981-1.754,17.855
			c-0.024,0.108-0.043,0.217-0.063,0.326c-4.469,22.307-16.837,42.275-34.847,56.241C293.69,299.576,275.247,306,256,306
			s-37.69-6.424-53.351-18.589c-3.585-2.774-6.997-5.843-10.145-9.126C179.889,265.143,171.357,248.862,167.817,231.183z M246,492
			h-80v-23c0-5.523-4.477-10-10-10s-10,4.477-10,10v23h-20V351.474c6.49-2.447,13.176-4.078,20-4.882V409c0,5.523,4.477,10,10,10
			s10-4.477,10-10v-63h25.715L246,403V492z M206,332v-18.626C221.431,321.669,238.427,326,256,326c17.574,0,34.571-4.332,50-12.625
			V332l-50,52.5L206,332z M386,492h-20v-23c0-5.523-4.477-10-10-10s-10,4.477-10,10v23h-80v-89l54.285-57H346v63
			c0,5.523,4.477,10,10,10s10-4.477,10-10v-62.408c6.824,0.804,13.509,2.436,20,4.883V492z M446,492h-40V362.121
			c24.418,17.307,40,46.461,40,76.879V492z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>
